import { useEffect } from 'react'
import ModalActionButton from '../../elements/ModalActionButton'
import RadioGroup from '../../elements/form/RadioGroup'
import { useState } from 'react'
import SearchField from '../../elements/SearchField'
import { debounce } from '../../../utils'
import { useDispatch, useSelector } from 'react-redux'
import { fetchStudents } from '../../../store/actions/studentsActions'
import StudentsFilters from '../../elements/filters/StudentsFilters'
import EmptyState from '../../elements/EmptyState'
import Loader from '../../elements/Loader'
import ApplicantTableSnippet from '../applications/ApplicantTableSnippet'
import CheckIcon from '../../elements/icons/CheckIcon'
import { ERROR, GET_STUDENTS } from '../../../store/types'
import CloseIcon from '../../elements/icons/CloseIcon'
import { Switch } from '@headlessui/react'
import DateField from '../../elements/form/DateField'
import { createInvoiceAssignment } from '../../../store/actions/invoicesActions'
import SelectField from '../../elements/form/SelectField'

const AssignInvoice = ({invoice, closeFunction}) => {
    const dispatch = useDispatch()
    const studentsSelector = useSelector(state => state.students)
    const invoicesSelector = useSelector(state => state.invoices)
    const assignmentTypes = [
        {
            label: 'All Active Students',
            value: 'ALL'
        },
        {
            label: 'Specific Student(s)',
            value: 'SPECIFIC'
        },
        {
            label: 'A Group of Students',
            value: 'GROUP'
        },
    ]

    const [validationErrors, setValidationErrors] = useState({});
    const [assignmentPayload, setAssignmentPayload] = useState({});
    const [sundriesRequirement, setSundriesRequirement] = useState({});

    useEffect(() => {
        dispatch({
            type: GET_STUDENTS,
            payload: []
        })

        if(assignmentPayload?.assignmentType === 'SPECIFIC') {
            dispatch(fetchStudents('', 1, 10))
        }
        
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [assignmentPayload?.assignmentType]);

    const searchStudents = debounce((term) => {
        if(!term || term === '') {
            dispatch({
                type: GET_STUDENTS,
                payload: []
            })
        }
        dispatch(fetchStudents(`searchTerm=${term}`, 0, 0))
    })

    const filterStudents = (filters) => {
        // if(!term || term === '') setReload(reload + 1)
        dispatch(fetchStudents(filters, 0, 0))
    }

    const [selectedStudents, setSelectedStudents] = useState([]);

    const toggleStudentSelect = (student) => {
        let temp = [...selectedStudents]
        if(studentSelected(student._id)) {
            temp = temp.filter(s => s._id !== student._id)
        } else {
            temp.push(student)
        }
        setSelectedStudents(temp)
    }

    const studentSelected = (studentId) => {
        const isSelected = selectedStudents.find(student => {
            return student._id === studentId
        })

        return isSelected ? true : false 
    }

    const validateForm = () => {
        let errors = {}

        if(sundriesRequirement.include) {
            if(!sundriesRequirement.dateFrom || sundriesRequirement.dateFrom === '') {
                errors.sundriesDateFrom = true
            }
            if(!sundriesRequirement.dateTo || sundriesRequirement.dateTo === '') {
                errors.sundriesDateTo = true
            }

            if(topupSundries && (!sundriesRequirement.sundryTopupFee || sundriesRequirement.sundryTopupFee === '')) {
                errors.sundryTopupFee = true
            }
        }

        setValidationErrors(errors)

        return errors
    }

    const pushAssignments = () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }

        const payload = {
            assignmentType: assignmentPayload.assignmentType,
            paymentDeadline: assignmentPayload.paymentDeadline || undefined,
            invoice: invoice._id,
            assignNewStudents,
            sundries: sundriesRequirement,
            students: selectedStudents.map(student => {return student._id})
        }

        dispatch(createInvoiceAssignment(payload))
    }

    const resetStudentsList = () => {
        setSelectedStudents([])
        dispatch({
            type: GET_STUDENTS,
            payload: []
        })
    }

    const [assignNewStudents, setAssignNewStudents] = useState(false);

    const [topupSundries, setTopupSundries] = useState(false)

    return (
        <div className='w-full'>
            <div className={assignmentPayload.assignmentType && assignmentPayload.assignmentType !== 'ALL' && `min-h-[600px]`}>
                <div className='border-b pb-[10px] mb-[10px]'>
                    <div className='mt-4'>
                        <RadioGroup 
                            items={assignmentTypes} 
                            inline={true}
                            preSelectedIndex={''}
                            inputLabel={'Assignment Type'}
                            requiredField={true}
                            returnSelected={(value) => {
                                resetStudentsList()
                                setAssignmentPayload({...assignmentPayload, ...{assignmentType: value.value}})
                            }} 
                            hasError={validationErrors && validationErrors.type}  
                            titleField='label'
                        />
                    </div>

                    <div className='mb-[10px] flex items-start justify-between gap-x-[10px] mt-[10px]'>
                        <div className='w-10/12'>
                            <p className="block font-space-grotesk text-[14px] font-[550] font-sofia-pro">Add Student Sundries</p>
                            <label className="text-sm text-gray-500 font-sofia-pro">Flip this switch to add the student's unpaid sundry expenses to this invoice.</label>
                        </div>
                        <div className='w-2/12 flex flex-row-reverse pt-[15px]'>
                            <Switch
                                checked={sundriesRequirement.include}
                                onChange={()=>{setSundriesRequirement({...sundriesRequirement, include: !sundriesRequirement.include})}}
                                className={`${
                                    sundriesRequirement.include ? 'bg-accent' : 'bg-gray-400'
                                } relative inline-flex items-center h-5 rounded-full w-10`}
                                >
                                <span className="sr-only">Add Sundries</span>
                                <span
                                    className={`transform transition ease-in-out duration-200 ${
                                        sundriesRequirement.include ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                                    } inline-block w-3 h-3 transform rounded-full`}
                                />
                            </Switch>
                        </div>
                    </div>

                    {sundriesRequirement.include && 
                        <>
                            <div className='w-full mt-[10px] mb-[10px]'>
                                <div className='w-full'>
                                    <p className='text-sm'>Select a date range to pick sundry expenses from</p>

                                    <div className='w-full flex items-start justify-between gap-x-[5px]'>
                                        <div className='my-2 w-full'>
                                            <DateField
                                                inputLabel="Date From" 
                                                fieldId="sundry-date-from" 
                                                requiredField={false}
                                                inputType="text" 
                                                preloadValue={''}
                                                hasError={validationErrors && validationErrors.sundriesDateFrom} 
                                                returnFieldValue={(value)=>{
                                                    const formattedDate = new Date(value)
                                                    setSundriesRequirement({...sundriesRequirement, ...{dateFrom: formattedDate}})
                                                }}
                                            />
                                        </div>
                                        <div className='my-2 w-full'>
                                            <DateField
                                                inputLabel="Date to" 
                                                fieldId="sundry-date-to" 
                                                requiredField={false}
                                                inputType="text" 
                                                preloadValue={''}
                                                hasError={validationErrors && validationErrors.sundriesDateTo} 
                                                returnFieldValue={(value)=>{
                                                    const formattedDate = new Date(value)
                                                    setSundriesRequirement({...sundriesRequirement, ...{dateTo: formattedDate}})
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            <div className='my-[10px] flex items-start justify-between gap-x-[10px] mt-[10px]'>
                                <div className='w-10/12'>
                                    <p className="block font-space-grotesk text-[14px] font-[550] font-sofia-pro">Refill sundries</p>
                                    <label className="text-sm text-gray-500 font-sofia-pro">Flip this switch to refill the student sundries back to the required amount.</label>
                                </div>
                                <div className='w-2/12 flex flex-row-reverse pt-[15px]'>
                                    <Switch
                                        checked={topupSundries}
                                        onChange={()=>{setTopupSundries(!topupSundries)}}
                                        className={`${
                                            topupSundries ? 'bg-accent' : 'bg-gray-400'
                                        } relative inline-flex items-center h-5 rounded-full w-10`}
                                        >
                                        <span className="sr-only">Topup Sundries</span>
                                        <span
                                            className={`transform transition ease-in-out duration-200 ${
                                                topupSundries ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                                            } inline-block w-3 h-3 transform rounded-full`}
                                        />
                                    </Switch>
                                </div>
                            </div>

                            {topupSundries && 
                                <div className='w-full mt-[10px]'>
                                    <div className='w-full my-2'>
                                        <SelectField
                                            selectOptions={invoice?.fees?.map(fee => fee.fee)}
                                            inputLabel="Select sundry fee"
                                            titleField="name"
                                            displayImage={false} 
                                            imageField=""
                                            requiredField={false}
                                            preSelectedIndex={invoice?.fees?.map(fee => fee.fee)?.findIndex(fee => fee?._id === sundriesRequirement.sundryTopupFee)}
                                            fieldId="center-select"
                                            hasError={validationErrors.sundryTopupFee}
                                            // return id of accounts of the selected option
                                            returnFieldValue={(value) => {
                                                setSundriesRequirement({...sundriesRequirement, ...{sundryTopupFee: value._id}})
                                            }}
                                        /> 
                                        <p className='mt-1 text-[13px] text-gray-500'>This is the fee that tops up the sundry balance - if there's none in the invoice, edit the invoice to add one.</p>
                                    </div>
                                </div>
                            }
                        </>                       
                    }

                    <div className='my-2 w-full'>
                        <DateField
                            inputLabel="Payment Deadline" 
                            fieldId="payment-deadline" 
                            requiredField={false}
                            inputType="text" 
                            preloadValue={''}
                            hasError={validationErrors && validationErrors.startDate} 
                            returnFieldValue={(value)=>{
                                const formattedDate = new Date(value)
                                setAssignmentPayload({...assignmentPayload, ...{paymentDeadline: formattedDate}})
                            }}
                        />
                    </div>
                </div>

                {assignmentPayload.assignmentType === 'SPECIFIC' && 
                    <>
                        <p className='text-sm text-gray-500 mb-[10px]'>Search for one or more students and click on the check mark to add each student to the list of assignees for this invoice.</p>
                        {selectedStudents.length > 0 && 
                            <>
                                <p className='font-medium text-sm underline mb-[10px]'>Selected Students (<span className='font-space-grotesk'>{selectedStudents.length}</span>) </p>
                                <div className='flex items-start gap-x-[5px] flex-wrap'>
                                    {selectedStudents.map((student, studentIndex)=>(<div key={studentIndex} className='rounded bg-gray-100 p-[5px] mb-[5px] flex items-start justify-between gap-x-[10px]'>
                                        <div className='w-full'>
                                            <p className='text-xs'>{student.fullName}</p>
                                            <p className='text-xs text-gray-500'>{student.admissionNumber}</p>
                                        </div>
                                        <button onClick={()=>{toggleStudentSelect(student)}}>
                                            <CloseIcon className={`w-4 h-4`} />
                                        </button>
                                    </div>))}
                                </div>
                            </>
                        }
                        <div className='w-full'>
                            <SearchField 
                                placeholderText={`Search by student name or admission number`}
                                showResultsDropDown={false}
                                triggerSearch={(term)=>{searchStudents(term)}}
                                performingSearch={studentsSelector.loadingStudents}
                            />
                        </div>
                        {studentsSelector.loadingStudents ? 
                            <Loader />
                        :
                        <div className='overflow-y-scroll scrollbar-hidden max-h-[550px]'>
                            {studentsSelector?.students?.students?.length > 0 ? <div className='mt-[10px] w-full'>
                                {studentsSelector?.students?.students?.map((student, studentIndex) => (
                                    <div key={studentIndex} className='flex items-start justify-between py-[10px] border-b border-gray-300'>
                                        <ApplicantTableSnippet 
                                            applicant={student} 
                                            showAdmissionNumber={true} 
                                            imageHeightClass='h-[35px]'
                                            imageWidthClass='w-[35px]'
                                        />
                                        <button onClick={()=>{toggleStudentSelect(student)}} className={`
                                            p-[2px] rounded transition duration-200 ${studentSelected(student._id) ? 
                                            'bg-gray-600 text-white hover:text-gray-300 active:bg-black' 
                                            : 
                                            'bg-gray-100 text-gray-400  active:bg-white hover:text-gray-600'}
                                        `}>
                                            {studentSelected(student._id) ? 
                                                <CloseIcon className="w-5 h-5" /> 
                                                :
                                                <CheckIcon className="w-5 h-5" />
                                            }
                                        </button>
                                    </div>
                                ))}
                            </div>
                            :
                            <div className='mt-[10px]'>
                                <EmptyState emptyStateText={`No students found matching your search`} />
                            </div>
                            }
                        </div>}
                    </>
                }

                {assignmentPayload.assignmentType === 'GROUP' && 
                    <>
                        <p className='text-sm text-gray-500 mb-[10px]'>Use the filters below to filter for the assignees of this invoice.</p>
                        <div className='w-full flex items-start justify-between my-5 p-2 rounded-md border'>
                            <div className='w-full'>
                                <StudentsFilters 
                                    applyFilters={(filters)=>{
                                        console.log('filters => ', filters)
                                        filterStudents(filters)
                                    }} 
                                    filtersToHide={['tribe', 'languages', 'parent']}
                                />
                            </div>
                        </div>
                        

                        {studentsSelector.loadingStudents ? 
                            <Loader />
                        :
                        <>
                            {studentsSelector.students?.students?.length > 0 ? 
                                <>
                                    <div className='w-full text-center mt-[20px]'>
                                        <h3 className='font-space-grotesk text-gray-700 font-[550] text-[24px]'>{studentsSelector.students?.total}</h3> 
                                        <p className='text-gray-500'>
                                        matches found for selected filters</p>
                                    </div> 
                                    <div className="w-full flex justify-between gap-x-4 mt-4 border-opacity-50 px-4 pt-4 border-t border-gray-300">
                                        <div className='w-10/12'>
                                            <label className="block text-sm font-medium text-gray-700 font-sofia-pro">Assign new students</label>
                                            <label className="text-xs text-gray-500 font-sofia-pro">Flip this switch to assign any students added in the future that match the filters selected above.</label>
                                        </div>
                                        <div className='w-2/12 flex flex-row-reverse'>
                                            <Switch
                                                checked={assignNewStudents}
                                                onChange={()=>{setAssignNewStudents(!assignNewStudents)}}
                                                className={`${
                                                    assignNewStudents ? 'bg-accent' : 'bg-gray-400'
                                                } relative inline-flex items-center h-5 rounded-full w-10`}
                                                >
                                                <span className="sr-only">Requires fee</span>
                                                <span
                                                    className={`transform transition ease-in-out duration-200 ${
                                                        assignNewStudents ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                                                    } inline-block w-3 h-3 transform rounded-full`}
                                                />
                                            </Switch>
                                        </div>
                                    </div>
                                </>
                                :
                                <div className='mt-[20px]'>
                                    <EmptyState emptyStateText={`No students found matching your search`} />
                                </div>
                            }
                        </>
                        }

                    </>
                }
            </div>
        
            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Assign Invoice`}
                    buttonAction={()=>{pushAssignments()}}
                    processing={invoicesSelector.creatingInvoiceAssignment}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-lg transition duration-200 hover:bg-opacity-20 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Cancel
                </button>
            </div>
        </div>
    )
}

export default AssignInvoice